/**
 * Dependências externas
 */
import isEqual from 'lodash/fp/isEqual';
import partialRight from 'lodash/fp/partialRight';
import compose from 'lodash/fp/compose';
import getHttpStatusError from './getHttpStatusError';

const is403Error = compose(partialRight(isEqual, [403]), getHttpStatusError);

export default is403Error;
